<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elevation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to cut off list" @click="$router.go(-1)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link appId="faceai" pageId="activation-self-service" color="white"></help-link>
                    <v-chip v-show="!loading" label :class="status.color" dark>
                        <span >{{ status.status }}</span>
                    </v-chip>
                </v-toolbar>
            </v-card>
            <v-alert :value="true" color="info" icon="info" outline>
                To enable your clock-in/clock-out with Facial Recognition, upload your two recent, different 2x2 photos (ideally 1680x1680 pixels and around 500KB each) with your face fully visible—no eyeglasses, hats, hair, or other coverings.  
            </v-alert>
            <v-layout row wrap> 
                <v-flex xs12>
                    <v-card class="elevation-1 transparent">
                        <v-toolbar flat height="40">
                            <span class="font-weight-bold">Enrolled Photos</span>
                            <v-spacer></v-spacer>
                            <v-btn v-if="hasAddRights&&!isMaxPhotoCount&&!loading" small class="primary" title="Add photo" @click="showAddPhoto">
                                <v-icon>add</v-icon>&nbsp;Add Photo&nbsp;
                            </v-btn>
                        </v-toolbar>
                        <v-data-table
                            :headers="isMobile?header_mobile:header"
                            :items="user_descriptors"
                            :loading="loading"  
                            hide-actions
                        >
                            <template v-slot:items="props">
                                <tr>
                                    <td>
                                        <v-img :src="commonfn.getFaceAIPhoto(props.item.photoFileName)" width="30"></v-img>
                                    </td>
                                    <td>{{ props.item.createdOn | moment('MMM DD, YYYY') }}</td>
                                    <td>Verified</td>
                                    <td v-if="!isMobile">
                                        <v-chip style="margin:-5px 0px 0px -5px;">
                                            <v-avatar>
                                                <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(props.item.createdBy.userId)"></v-img>
                                            </v-avatar>
                                            {{props.item.createdBy.firstName}} {{props.item.createdBy.lastName}} 
                                        </v-chip>
                                    </td>
                                    <td>
                                        <v-btn v-if="hasDeleteRights" icon small title="Delete" @click="showDelete(props.item)">
                                            <v-icon small>delete</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-flex>

        <v-dialog v-model="dialogUploadPhoto" persistent fullscreen hide-overlay transition="dialog-bottom-transition">   
            <upload-photo :pageKey="pageKeys.attendance_face_activation" @send="uploadHandler" :dialogUploadPhoto.sync="dialogUploadPhoto"></upload-photo>
        </v-dialog>

        <v-dialog v-model="dialogModelTraining" width="600" persistent>
            <v-card class="elevation-1" style="border-radius:4px;"> 
                <v-toolbar flat height="45px">
                    <span>Hang tight! We're setting things up. Please don’t close or refresh the page.</span>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-progress-linear :value="processingValue" color="primary" determinate height="3" style="margin-top:-3px;"></v-progress-linear>
                <v-card-text class="text-xs-center">
                    <p class="msg-text subheading">{{ processingText }}</p>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogDelete" width="500">
            <delete ref="refDeleteComponent" :dialogDelete.sync="dialogDelete" @okDelete="deletePhoto"></delete>
        </v-dialog>

    </v-layout> 
</template>

<script>

import * as faceapi from 'face-api.js'
import commonfn from '@/common/functions'   //for refactor
import faceAIApi from '@/api/faceai'
import pageKeys from '@/common/pagekeys'
import awsS3Helper from '@/helpers/aws-s3'
import { hasAddRights, hasDeleteRights } from '@/helpers/access-permissions'

export default {     
    name: 'FaceRecognitionActivition',
    metaInfo: {
        title: 'Face Recognition Activition',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'Face Recognition Activition' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'upload-photo': () => import('@/components/FaceRecognition/UploadPhoto'),
        'delete': () => import('@/components/BasicPopups/Delete')
    },
    data () {
        return {
            pageKeys,
            commonfn,
            awsS3Helper,
            error: false,
            errorMessage: '',
            loading: false,
            dialogUploadPhoto: false,
            dialogModelTraining: false,
            dialogDelete: false,
            processingValue: 0,
            header: [
                {text: 'Photo',align: 'left',value: '', width:'20%', sortable:false},
                {text: 'Uploaded On',align: 'left',value: '', width:'20%',sortable:false},
                {text: 'Status',align: 'left',value: '', width:'20%',sortable:false},
                {text: 'Created By',align: 'left',value: '', width:'20%',sortable:false},
                {text: 'Delete',align: 'left',value: '', width:'10%',sortable:false}
            ],
            header_mobile: [
                {text: 'Photo',align: 'left',value: '', width:'20%', sortable:false},
                {text: 'Uploaded On',align: 'left',value: '', width:'20%',sortable:false},
                {text: 'Status',align: 'left',value: '', width:'20%',sortable:false},
                {text: 'Delete',align: 'left',value: '', width:'10%',sortable:false}
            ],
            base64Image: null,
            photoFileName: null,
            descriptor: null,
            selectedUserFaceDescriptorId: null,
            user_descriptors: [],
            processingText: 'Starting...'
        }
    },
    methods: {
        showDelete(data) {
            this.$refs.refDeleteComponent.setMessage("Delete selected photo?")
            this.selectedUserFaceDescriptorId = data.userFaceDescriptorId
            this.dialogDelete = true
        },
        showAddPhoto() {
            this.dialogUploadPhoto = true
        },
        async uploadHandler(data) {
            this.dialogModelTraining = true

            this.base64Image = data.base64Image
            this.photoFileName = data.fileName

            //load models
            this.processingText = 'Starting...'
            this.processingValue = 25
            await this.loadModels()

            //train model
            this.processingText = 'Processing image...'
            this.processingValue = 50
            await this.trainModel()

            //save descriptors to db
            this.processingText = 'Saving progress...'
            this.processingValue = 75
            await this.saveDescriptor()

            //clear memory
            this.processingText = 'Wrapping up...'
            this.processingValue = 100
            await this.clearMemory()
            
            //display in grid
            await this.getUserDescriptors()

            this.dialogModelTraining = false
        },        
        async loadModels() {
            await faceapi.nets.tinyFaceDetector.loadFromUri('/face-ai/models')
            await faceapi.nets.faceLandmark68Net.loadFromUri('/face-ai/models')
            await faceapi.nets.faceRecognitionNet.loadFromUri('/face-ai/models')
        },
        async trainModel() {
            const label = `${this.$store.state.firstName}_${this.$store.state.lastName}`
            const img = new Image()
            img.src = this.base64Image

            await new Promise((resolve) => (img.onload = resolve))

            const detections = await faceapi
                .detectSingleFace(img, new faceapi.TinyFaceDetectorOptions())
                .withFaceLandmarks()
                .withFaceDescriptor()

            if (detections) {
                this.descriptor = new faceapi.LabeledFaceDescriptors(label, [detections.descriptor])
            }else{
                this.error = true
                this.errorMessage = "Error when processing your photo. Please contact support@sweldonow.ph"
            }
        },
        async saveDescriptor() {
            try{
                const data = {
                    photoFileName: this.photoFileName,
                    descriptors: JSON.stringify(this.descriptor.descriptors)
                }
                await faceAIApi.saveFaceDescriptors(data)
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        arrayStringifyReplacer(key, value) {
            if (Array.isArray(value)) {
                return JSON.stringify(value) // Keep array format as string
            }
            return value
        },
        async getUserDescriptors() {
            try{
                this.loading = true
                const response = await faceAIApi.getUserFaceDescriptors()
                if (response && response.status == 200) {
                    this.user_descriptors = response.data.items
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async deletePhoto() {
            try{
                const response = await faceAIApi.deleteUserFaceDescriptor(this.selectedUserFaceDescriptorId)
                if (response && response.status == 200) {
                    await this.getUserDescriptors()
                    this.dialogDelete = false
                }
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async clearMemory() {
            faceapi.nets.tinyFaceDetector.dispose()
            faceapi.nets.faceLandmark68Net.dispose()
            faceapi.nets.faceRecognitionNet.dispose()

            this.base64Image = null
            this.photoFileName = null
            this.descriptor = null
        }
    },
    async created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: 'Face Recognition Activation',
            headerPageTitle: ''
        })

        this.getUserDescriptors()
    },
    computed: {
        hasAddRights() {
            return hasAddRights(this.$router.currentRoute.path)
        },
        hasDeleteRights() {
            return hasDeleteRights(this.$router.currentRoute.path)
        },
        isMaxPhotoCount() {
            return this.user_descriptors.length == 2
        },
        status() {
            if (this.user_descriptors.length) {
                if (this.user_descriptors.length == 2) {
                    return {
                        status: 'Active',
                        color: 'green'
                    }
                } else {
                    return {
                        status: 'In Complete',
                        color: 'orange'
                    }
                }
            }else{
                return {
                        status: 'Inactive',
                        color: 'orange'
                    }
            }
        },
    }
}
</script>